/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseUserWeeklyScheduleExceptionDto } from '../../models/response-user-weekly-schedule-exception-dto';

export interface UserWeeklyScheduleExceptionsControllerFindAllByEmail$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * User email
 */
  email: string;
}

export function userWeeklyScheduleExceptionsControllerFindAllByEmail(http: HttpClient, rootUrl: string, params: UserWeeklyScheduleExceptionsControllerFindAllByEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseUserWeeklyScheduleExceptionDto>>> {
  const rb = new RequestBuilder(rootUrl, userWeeklyScheduleExceptionsControllerFindAllByEmail.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseUserWeeklyScheduleExceptionDto>>;
    })
  );
}

userWeeklyScheduleExceptionsControllerFindAllByEmail.PATH = '/thalea-google-events/user-weekly-schedule-exceptions/{tenant}/{email}';
